<template>
  <VCard class="bg-[#FFFFFF] p-4 shadow-none">
    <VCard
      class="bg-[#F5F5F7] shadow-none flex flex-col items-center justify-center gap-4 p-4 min-h-[500px]"
    >
      <span class="text-body-1 text-primary-text p-0">
        {{ t('No consultations found') }}
      </span>

      <VBtn
        v-if="canCreateConsultations"
        :to="{ name: routeNames.NEW_CONSULTATION }"
        :active="false"
        :disabled="disableConsultationButton"
        class="button-large"
        color="primary"
      >
        <span>
          {{ t('Create consultation') }}
        </span>
      </VBtn>
    </VCard>
  </VCard>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { routeNames } from '@/router/routeNames'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const { t } = useI18n()
const { hasGodModeShift, canCreateConsultations } = storeToRefs(useUserStore())
const disableConsultationButton = computed(() => hasGodModeShift.value)
</script>
